import { put } from "@readai/common/api";

export const connectTeamsAppConversation = async (
  token: string,
): Promise<void> => {
  return put(`/teamsapp/conversation?token=${token}`, null, {
    withCreds: true,
  });
};
